import React from "react";
import { Divider } from "oolib";
import { StyledWrapper, StyledTextInput } from "./styled";

interface SearchInputProps {
  value: string;
  onChange: (key: string | null, value: string) => void;
  placeholder?: string;
}

export const SearchInput = ({ value, onChange, placeholder = "Search" }: SearchInputProps) => {
  return (
    <StyledWrapper>
      <StyledTextInput
        value={value}
        onChange={onChange}
        placeholder={placeholder}
        icon="MagnifyingGlass"
        clearBtn={{ text: "Clear", variant: "tertiary" }}
        S
      />
    </StyledWrapper>
  );
};
